require('jquery-visible');

(function($) {
  $(() => {
    if($('.grid, .category__content, .search__content').length) {
      checkVisible();
    }

    $(window).on('scroll', function(e) {
      if($('.grid,.category__content, .search__content').length) {
        checkVisible();
      }
    });

    function checkVisible() {

      if($(window).width() < 576) {

        $('.grid__wrapper, .grid__item').each(function(i, k) {
          if($(this).find('img').length) {
            if ($(this).visible(false, false, 'vertical')) {
                $(k).addClass('active');
            } else {
                $(k).removeClass('active');
            }
          }
        });
      }
    }
  });
})(jQuery);